/** @format */

import React from "react";
import { Radio } from "antd";

export default ({
  disabled,
  label,
  value,
  handleChange,
  filterType,
  filterId,
}) => (
  <Radio
    disabled={disabled || false}
    label={label}
    filterId={filterId}
    filterType={filterType}
    checked={value}
    onChange={handleChange}
    defaultChecked={false}
  >
    {label === "True"
      ? "Yes"
      : label === "False"
      ? "No"
      : label === "Express custom" && filterType === "f_product_types"
      ? "Ready to make"
      : label}{" "}
  </Radio>
);
